export const videoCacheKey = {
  hashtag: {
    pageable: (pageRequest) => ['/videos', '/hashtags', pageRequest],
  },

  videos: (pageRequest) => ['/videos', '/hashtags', pageRequest],
};
